export interface ETLDataFeedObj {
    _id: string;
    CompanyID: number;
    FeedName: string;
    SourceSystemOrig?: string;
    SourceSystem: string;
    DataList: DataList[];
    QueuedOnImport: boolean;
    Status: Partial<Status>;
    IsEditable: boolean;
}

export interface FailedImportObj {
    ImportId: string;
    ReportingSetID?: string;
    FeedName?: string;
    SourceSystem?: string;
    ProcessStartTime: string;
    Reason: string;
}

export interface DataList {
    Name: string;
    DataType: number;
    isKey: boolean;
    isActive: boolean;
}

export interface Status {
    IsValid: boolean;
    ConsecutiveFailureCount: number;
    LastSuccessDate: string;
    LastFailureDate: string;
}

export interface ETLDataFeedDependencies {
    DefinitionID: string;
    Hierarchies: string[];
    BaseFeeds: string[];
    Joins: string[];
    MetricAbvs?: string[];
    CanDeleteEverything: boolean;
}

export interface ETLDataFeedDependency {
    Type: string;
    Name: string;
}

export const PERMISSION = {
    VIEW: "VIEW",
    CREATE: "CREATE"
}